import React from 'react';
import { Card, Skeleton, Space } from 'antd';

export const ReportSkeleton = () => {
  return (
    <div className="report-skeleton-wrap" style={{ width: '100%', marginTop: 8 }}>
      {/* Header: Title + Export Buttons */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 16,
          flexWrap: 'wrap',
          gap: 12,
        }}
      >
        <Skeleton.Input active style={{ width: 160, height: 28, borderRadius: 4 }} />
        <Space size="middle">
          <Skeleton.Button active style={{ width: 140, height: 36, borderRadius: 6 }} />
          <Skeleton.Button active style={{ width: 120, height: 36, borderRadius: 6 }} />
        </Space>
      </div>

      {/* Filter Toolbar Card */}
      <Card
        style={{
          borderRadius: 8,
          border: '1px solid #eaedf1',
          marginBottom: 20,
          background: '#ffffff',
        }}
        bodyStyle={{ padding: '16px 20px' }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
            gap: 14,
            alignItems: 'flex-end',
          }}
        >
          <div>
            <Skeleton.Input active size="small" style={{ width: 80, height: 12, marginBottom: 6, borderRadius: 3 }} />
            <Skeleton.Input active block style={{ height: 38, borderRadius: 6 }} />
          </div>
          <div>
            <Skeleton.Input active size="small" style={{ width: 100, height: 12, marginBottom: 6, borderRadius: 3 }} />
            <Skeleton.Input active block style={{ height: 38, borderRadius: 6 }} />
          </div>
          <div>
            <Skeleton.Input active size="small" style={{ width: 90, height: 12, marginBottom: 6, borderRadius: 3 }} />
            <Skeleton.Input active block style={{ height: 38, borderRadius: 6 }} />
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <Skeleton.Button active style={{ width: '100%', height: 38, borderRadius: 6 }} />
          </div>
        </div>
      </Card>

      {/* 4 Summary Statistics Cards */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: 16,
          marginBottom: 20,
        }}
      >
        {Array.from({ length: 4 }).map((_, idx) => (
          <Card
            key={'stat_' + idx}
            style={{
              borderRadius: 8,
              border: '1px solid #eaedf1',
              boxShadow: '0 1px 3px rgba(0, 0, 0, 0.02)',
              background: '#ffffff',
            }}
            bodyStyle={{ padding: '16px 20px' }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                <Skeleton.Input active size="small" style={{ width: 100, height: 14, borderRadius: 4 }} />
                <Skeleton.Input active style={{ width: 70, height: 30, borderRadius: 4 }} />
              </div>
              <Skeleton.Avatar active size={40} shape="circle" />
            </div>
          </Card>
        ))}
      </div>

      {/* Analytics Chart / Table Placeholder */}
      <Card
        style={{
          borderRadius: 8,
          border: '1px solid #eaedf1',
          background: '#ffffff',
        }}
        bodyStyle={{ padding: '20px' }}
      >
        <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
          <Skeleton.Input active size="small" style={{ width: 200, height: 18, borderRadius: 4 }} />
          <Skeleton.Button active size="small" style={{ width: 90, height: 26, borderRadius: 4 }} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {Array.from({ length: 6 }).map((_, rIdx) => (
            <div
              key={'rep_row_' + rIdx}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '10px 0',
                borderBottom: rIdx === 5 ? 'none' : '1px solid #f1f5f9',
              }}
            >
              <Skeleton.Input active size="small" style={{ width: '30%', height: 16, borderRadius: 4 }} />
              <Skeleton.Input active size="small" style={{ width: '20%', height: 16, borderRadius: 4 }} />
              <Skeleton.Input active size="small" style={{ width: '15%', height: 16, borderRadius: 4 }} />
              <Skeleton.Button active size="small" style={{ width: 80, height: 22, borderRadius: 12 }} />
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
};

export default ReportSkeleton;

